import { IColumnsItem } from '@/components/custom-table/type.d';
import { IGetDictionaryListRes } from '@/api/system-config/type.d';
import { DICTIONARY_CHANNEL_ENUM, DICTIONARY_STATUS_ENUM } from '@/constant';

export const renderColumns = (
  handleEditItem: (row: IGetDictionaryListRes['list'][0]) => void,
  handleDelItem: (code: string) => void,
  handleValueItem: (row: IGetDictionaryListRes['list'][0]) => void,
  handleUpdateStatus: (row: IGetDictionaryListRes['list'][0]) => void,
  canUpdate: boolean,
  canDelete: boolean,
  canValueManage: boolean,
): IColumnsItem<IGetDictionaryListRes['list'][0]>[] => [
  {
    width: '50',
    type: 'selection',
  },
  {
    label: '字典编号',
    prop: 'code',
    width: '180',
  },
  {
    label: '字典名称',
    prop: 'name',
    width: '180',
  },
  {
    label: '排序',
    prop: 'sort',
    width: '80',
  },
  {
    label: '渠道',
    width: '80',
    render: row => (
      <div>
        {row.channel === DICTIONARY_CHANNEL_ENUM.BACKGROUND && <el-tag size="default">后台</el-tag>}
        {row.channel === DICTIONARY_CHANNEL_ENUM.INTERFACE && <el-tag size="default">接口</el-tag>}
      </div>
    ),
  },
  {
    label: '启用/禁用',
    width: '100',
    render: row => (
      <div>
        <el-switch
          modelValue={row.isEnable}
          active-value={DICTIONARY_STATUS_ENUM.ENABLE}
          inactive-value={DICTIONARY_STATUS_ENUM.DISENABLE}
          onClick={() => handleUpdateStatus(row)}
        ></el-switch>
      </div>
    ),
  },
  {
    label: '备注',
    prop: 'remark',
    ellipsis: true,
  },
  {
    label: '操作',
    width: '150',
    align: 'center',
    fixed: 'right',
    render: row => (
      <div class="flex flex-wrap btns">
        {canUpdate && <el-button
          size="default"
          type="text"
          onClick={() => handleEditItem(row)}
        >
          编辑
        </el-button>}
        {canDelete && <el-button
          size="default"
          type="text"
          onClick={() => handleDelItem(row.code)}
        >
          删除
        </el-button>}
        {canValueManage && <el-button
          size="default"
          type="text"
          onClick={() => handleValueItem(row)}
        >
          值管理
        </el-button>}
      </div>
    ),
  },
];
